import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import "./LoadingSpinner.css";

const LoadingSpinner = ({
  size = 40,
  message = "Loading...",
  fullScreen = false,
  color = "primary",
}) => {
  const containerProps = fullScreen
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        zIndex: 9999,
      }
    : {
        width: "100%",
        minHeight: "200px",
      };

  return (
    <Box
      className="loading-spinner"
      data-testid="loading-spinner"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        ...containerProps,
      }}
    >
      <CircularProgress size={size} color={color} />
      {message && (
        <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
